import React from 'react';
import { useVideoUpload } from '../context/VideoUploadContext';
import './BackgroundUploadWidget.scss';

export const BackgroundUploadWidget = () => {
  const { uploadState, minimizeWidget, expandWidget, dismissWidget } = useVideoUpload();

  if (!uploadState.isVisible) return null;

  const { isUploading, progress, fileName, status, error, isMinimized } = uploadState;

  if (isMinimized) {
    return (
      <div className="buw-minimized" onClick={expandWidget} title="Click to view upload details">
        {status === 'error' ? (
          <i className="bi bi-exclamation-circle-fill buw-icon-error" />
        ) : status === 'success' ? (
          <i className="bi bi-check-circle-fill buw-icon-success" />
        ) : (
          <div className="buw-minimized-spinner">
            <span className="buw-minimized-progress">{progress}%</span>
          </div>
        )}
        <span className="buw-minimized-label">
          {status === 'success' ? 'Uploaded' : status === 'error' ? 'Failed' : 'Uploading...'}
        </span>
      </div>
    );
  }

  return (
    <div className={`buw-container ${status}`}>
      {/* Widget Header */}
      <div className="buw-header">
        <div className="buw-title-group">
          {status === 'error' ? (
            <i className="bi bi-exclamation-triangle-fill buw-header-icon error" />
          ) : status === 'success' ? (
            <i className="bi bi-check-circle-fill buw-header-icon success" />
          ) : (
            <i className="bi bi-cloud-arrow-up-fill buw-header-icon uploading" />
          )}
          <span className="buw-title">
            {status === 'uploading' && 'Uploading Video...'}
            {status === 'processing' && 'Processing Video...'}
            {status === 'success' && 'Upload Complete!'}
            {status === 'error' && 'Upload Failed'}
          </span>
        </div>
        <div className="buw-controls">
          <button className="buw-ctrl-btn" onClick={minimizeWidget} title="Minimize">
            <i className="bi bi-dash-lg" />
          </button>
          {!isUploading && (
            <button className="buw-ctrl-btn" onClick={dismissWidget} title="Close">
              <i className="bi bi-x-lg" />
            </button>
          )}
        </div>
      </div>

      {/* Widget Body */}
      <div className="buw-body">
        <div className="buw-file-name" title={fileName}>
          <i className="bi bi-file-earmark-play-fill me-1" />
          {fileName || 'video.mp4'}
        </div>

        {status === 'error' ? (
          <div className="buw-error-msg">{error || 'An error occurred during upload.'}</div>
        ) : (
          <>
            {/* Progress Bar */}
            <div className="buw-progress-bg">
              <div
                className={`buw-progress-fill ${status}`}
                style={{ width: `${progress}%` }}
              />
            </div>

            {/* Status Footer Meta */}
            <div className="buw-meta">
              <span className="buw-status-text">
                {status === 'uploading' && `Uploading: ${progress}%`}
                {status === 'processing' && 'Finishing up on server...'}
                {status === 'success' && 'Your video is now live on feed!'}
              </span>
              <span className="buw-percent">{progress}%</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
